
import React, { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { 
  Users, 
  BookOpen, 
  Target, 
  FileText, 
  Settings, 
  BarChart3, 
  Calendar,
  LogOut,
  Gift
} from 'lucide-react'
import { supabase } from '@/integrations/supabase/client'
import { useNavigate } from 'react-router-dom'
import AdminUsers from '@/components/admin/AdminUsers'
import AdminModules from '@/components/admin/AdminModules'
import AdminTasks from '@/components/admin/AdminTasks'
import AdminResources from '@/components/admin/AdminResources'
import AdminQuizzes from '@/components/admin/AdminQuizzes'
import AdminEvents from '@/components/admin/AdminEvents'
import AdminRewards from '@/components/admin/AdminRewards'

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('users')
  const navigate = useNavigate()

  const navigationItems = [
    { id: 'users', label: 'Users', icon: Users },
    { id: 'modules', label: 'Learning Modules', icon: BookOpen },
    { id: 'tasks', label: 'Tasks', icon: Target },
    { id: 'resources', label: 'Resources', icon: FileText },
    { id: 'quizzes', label: 'Quiz Management', icon: BarChart3 },
    { id: 'events', label: 'Events', icon: Calendar },
    { id: 'rewards', label: 'Rewards', icon: Gift }
  ]

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut()
      navigate('/admin/login')
    } catch (error) {
      console.error('Error signing out:', error)
    }
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'users':
        return <AdminUsers />
      case 'modules':
        return <AdminModules />
      case 'tasks':
        return <AdminTasks />
      case 'resources':
        return <AdminResources />
      case 'quizzes':
        return <AdminQuizzes />
      case 'events':
        return <AdminEvents />
      case 'rewards':
        return <AdminRewards />
      default:
        return <AdminUsers />
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex">
        {/* Sidebar - Restored Original Design */}
        <div className="w-64 bg-white shadow-lg">
          <div className="p-6">
            <div className="flex items-center justify-between mb-6">
              <h1 className="text-2xl font-bold text-gray-800">Admin Portal</h1>
              <Button 
                onClick={handleLogout}
                variant="ghost"
                size="sm"
                className="text-gray-600 hover:text-gray-800"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Logout
              </Button>
            </div>
          </div>
          <nav className="mt-6">
            {navigationItems.map((item) => {
              const Icon = item.icon
              return (
                <button
                  key={item.id}
                  onClick={() => setActiveTab(item.id)}
                  className={`w-full flex items-center px-6 py-3 text-left hover:bg-gray-100 transition-colors ${
                    activeTab === item.id ? 'bg-blue-50 border-r-2 border-blue-500 text-blue-600' : 'text-gray-700'
                  }`}
                >
                  <Icon className="w-5 h-5 mr-3" />
                  {item.label}
                </button>
              )
            })}
          </nav>
        </div>

        {/* Main Content - Restored Original Design */}
        <div className="flex-1 p-8">
          {renderContent()}
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard
